<template>
  <div class="main-billings-overview">
    <Panel>
      <h2 slot="header">{{ 'titles.invoices' | trans }}</h2>
      <Invoices />
    </Panel>
    <router-view :current=current :plans=plans />
    <Loading v-if="loading" class="absolute" />
  </div>
</template>

<script>
  import Invoices from '../billings/components/Invoicestwo.vue'
  import Item from '@/helpers/components/display/Item'
  import BillingPlans from '../billings/components/BillingPlans'
  import CreditsUsage from '../billings/components/CreditsUsage'
  import Unpaid from '../billings/components/Unpaid'
  import invoices_mixin from '../billings/invoices'
  import {dateFromApi} from '@/providers/fields'
  import {startOfMonth, endOfMonth} from 'date-fns'
  import _ from 'lodash'

  export default {
    name: 'InvoiceDetail',
    mixins: [invoices_mixin],
    components: {
      Invoices,
      Item,
      BillingPlans,
      CreditsUsage,
      Unpaid,
      PointsBalance: {
        props: ['all_plans', 'billing', 'date'],
        template:
          '<div class="billing-points-cost">\
            <h4>\
              <slot name=title />\
              <br/>\
              ({{ String(date.getMonth()+1).padStart(2, "0") }}.&nbsp;{{date.getFullYear()}})\
            </h4>\
            <div class="points">\
              <span>{{ billing.log_apptokens_resource_credits_used | number(3) }}\
              <template v-if="getBillingPlan(billing)">\
                /\
                <template v-if="Number(getBillingPlan(billing).credits) === 0">\
                  <span class="as-icon">∞</span>\
                </template>\
                <template v-else>\
                  {{ getBillingPlan(billing).credits | number(3) }}\
                </template>\
              </template></span>\
              <Icon name="CR" />\
            </div>\
            <div class="cost">\
              {{ \'billings:invoices.cost\' | trans }}:\
              <label>{{ billing.cost_final | number(2) }} &euro;</label>\
            </div>\
            <div class=action><slot /></div>\
          </div>',
        methods: {
          getBillingPlan (billing) {
            if (!billing.billings_contracts || !billing.billings_contracts.length) {
              return false;
            }
            var id = billing.billings_contracts.billings_plans_id;
            if (this.all_plans) {
              var plan = this.all_plans.filtered(id);
              return plan.length ? plan : false;
            }
          },
        },
      },
    },
    data() {
      var now = new Date();
      return {
        today: now,
        token_id: '',
        loading: false,
        previous: new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          15 //middle of month
        ),
      };
    },
    computed: {
      contract () {
        return this.$store.getters.billing_plan;
      },
      current_billing () {
        return this.billing4month(this.today);
      },
      previous_billing () {
        return this.billing4month(this.previous);
      },
      plans () {
        if (this.all_plans) {
          return this.all_plans.filtered('visible', '1');
        }
      },
    },
    asyncComputed: {
      billings () {
        return this.async('apptoken')
        .then(apptoken => this.api.get(
        'billings' +
            '?include=billings_contracts,billings_transactions' +
            '&filter=apptokens_id::eq::' + this.$route.params.id +
            '&sort=id::desc' +
            '&range=0,50'
        ));
      },
      all_plans () {
        return this.api.get('billings_plans?range=all');
      },
      current () {
        return this.async('billing_plan', b => b.billings_plans);
      },
    },
    methods: {
      billing4month (date) {
        if (typeof date !== 'number') {
          date = Date.parse(date);
        }
        var start_month = startOfMonth(new Date(date));
        var end_month = endOfMonth(new Date(date));
        if (this.billings) {
          var month = this.billings.filter(b => {
            if (!b.target_time_resource_query_start || !b.target_time_resource_query_end) {
              return false;
            }
            var start = dateFromApi(b.target_time_resource_query_start);
            var end = dateFromApi(b.target_time_resource_query_end);
            if (!start || !end) {
              return false;
            }
            return start >= start_month && end >= start_month && start <= end_month && end <= end_month;
          });
          return month.length ? this.compute(month.pluck()) : false;
        }
      },
      cancel_contract () {
        return document.toastconfirm(
          this.$t('billings:cancel.confirm'),
          this.$t('billings:cancel.title'),
          this.$t('buttons.back'),
          this.$t('billings:cancel.title'),
        ).then(confirmed => {
          if (!confirmed) {
            return;
          }
          this.loading = true;
          return this.api
            .delete('billings_contracts/' + this.contract.id)
            .toast(false)
            .then(() => this.$store.commit('refresh'))
            .finally(() => this.loading = false)
          ;
        })
      },
      change_locked (locked_after_cap) {
        if (!this.contract || !this.contract.length) {
          return;
        }
        this.loading = true;
        return this.api.put(
            'billings_contracts/' + this.contract.id,
            {locked_after_cap}
          )
          .toast(false)
          .then(() => this.$store.commit('refresh'))
          .finally(() => this.loading = false)
        ;
      },
    },
    created () {
      window.localStorage.setItem('InvoiceDetailID', this.$route.params.id);
    }
  }
</script>

<style lang="scss">
  .main-billings-overview {
    .enkronos-credits-usage {
      margin-top: 10px;
    }
    h2.center {
      float: none !important;
      @media (min-width: $min-md) {
        margin: 0 100px;
      }
    }
    .cancel-link {
      cursor: pointer;
      @media (max-width: $max-sm) {
        display: block;
        float: none !important;
      }
      &:hover {
        color: $accent;
      }
    }
    position: relative;
    .holder.plan-locking {
      @media (min-width: $xs-min) {
        padding-left: 3*$gutter;
        padding-right: 3*$gutter;
      }
      .btn {
        margin: 5px;
      }
      p {
        text-align: justify;
        @include font-size(18px);
      }
    }
    .billing-months {
      text-align: center;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      align-items: stretch;
      margin: 0 #{-10px};
      .preview {
        font-weight: 700;
        color: $accent;
      }
      > .billing-points-cost {
        display: inline-flex;
        flex-direction: column;
        margin: 10px;
        width: 100%;
        max-width: 390px;
        > * {
          border: solid $body-bg 2px;
          margin-bottom: 10px;
          padding: 5px 12px;
          &:empty {
            display: none;
          }
        }
        > *:last-child {
          flex-grow: 1;
        }
        > h4 {
          border-bottom: none;
          margin-bottom: 0;
        }
        > h4, > .cost {
          @include font-size(18px, 23px);
          color: $accent-color;
          font-weight: 400;
        }
        > .points, > .cost > label {
          font-weight: 700;
          @include font-size(20px);
          display: block;
          > span, > svg {
            vertical-align: middle;
          }
          > svg {
            transform: scale(1.1);
          }
        }
      }
      span.status {
        text-transform: uppercase;
        font-weight: 700;
        &.paid {
          color: $state-success;
        }
        &.pending {
          color: $state-warning;
        }
        &.not_paid {
          color: $state-error;
        }
      }
    }
    .current {
      text-align: center;
      h2 > span {
        color: $accent;
        text-transform: uppercase;
      }
      .data {
        display: inline-block;
        width: 400px;
        max-width: 100%;
      }
    }
    .planslist {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/general/InvoiceDetail.vue